import { useState } from 'preact/hooks';
import { money, nf } from '../logica/dinero';
import type { Pedido } from '../logica/pedidos';

const cop = (v: number) => money(v, 'COP');

// Lo que pagó el negocio a la transportadora por este pedido, contra lo que cobró al cliente. Se guarda al salir del campo.
// Vacío = sin registrar (Resultados avisa); 0 = no costó.
export function CostoEnvio({ pedido, cobradoCop, onGuardar }: { pedido: Pedido; cobradoCop: number; onGuardar: (v: number | null) => Promise<void> | void }) {
  const guardado = pedido.costo_envio ?? null, [v, setV] = useState<number | null>(guardado);
  const dif = v == null ? null : cobradoCop - v;
  return (
    <section class="panel form-sec" aria-label="Costo del envío">
      <h3>Costo del envío</h3>
      <div class="row abajo">
        <div class="field corto"><label for="f-costo-envio">Lo que pagaste a la transportadora (COP)</label>
          <input id="f-costo-envio" class={'in r' + (v == null ? ' err' : '')} type="text" inputmode="numeric" placeholder="Sin registrar" value={v == null ? '' : nf(v)}
            onInput={e => { const d = e.currentTarget.value.replace(/\D/g, ''); setV(d === '' ? null : +d); }}
            onBlur={() => { if (v !== guardado) onGuardar(v); }} onKeyDown={e => { if (e.key === 'Enter') e.currentTarget.blur(); }} /></div>
        <dl class="kv costo-envio">
          <dt>Cobrado al cliente</dt><dd>{cobradoCop ? cop(cobradoCop) : 'Envío gratis'}</dd>
          <dt>Pagado por el despacho</dt><dd>{v == null ? 'Sin registrar' : cop(v)}</dd>
          <dt>Diferencia</dt><dd class={dif != null && dif < 0 ? 'malo' : ''}>{dif == null ? '—' : dif >= 0 ? `El envío dejó ${cop(dif)}` : `El envío costó ${cop(-dif)} más de lo cobrado`}</dd>
        </dl>
      </div>
      {v == null
        ? <p class="nota">Falta el costo del envío: mientras no lo registres, Resultados no resta este despacho del gasto logístico y la utilidad se ve más alta de lo real.</p>
        : <span class="hint">Cuenta en Resultados, en el mes del pedido: lo cobrado al cliente es ingreso y lo pagado por el despacho es gasto.</span>}
    </section>
  );
}
